import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0150d31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plaque-report-page" }
const _hoisted_2 = { class: "plaque-report-page__content" }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { WReportHeader } from '@/widgets/WReportHeader'
import { WReportImages } from '@/widgets/WReportImages'
import { WReportComments } from '@/widgets/WReportComments'
import { WSendToBot } from '@/widgets/WSendToBot'
import { WReportSubmit } from '@/widgets/WReportSubmit'
import { WReportRecommendations } from '@/widgets/WReportRecommendations'
import PlaqueReportPreview from './components/PlaqueReportPreview.vue'
import { EObservationHistory } from '@/entities/EObservationHistory'
import { EResultAnalyzes } from '@/entities/EResultAnalyzes'
import { WReportPrint } from '@/widgets/WReportPrint'
import {
  AppointmentType,
  CommentTemplateType,
  CommentType,
  ConsultationType,
  ObservationHistoryType,
  ReportDetailType,
  ResultAnalyzesType,
} from '@/shared/types'
import { showErrorMessage } from '@/shared/utils'
import { organizationsApi, patientApi, reportApi, userApi } from '@/shared/api'
import { REPORT_VIEW } from '@/shared/constants'
import { useReportListing } from '@/shared/composables'
import { PlaqueReportController } from './plaqueReport'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const { setUpdateReportListing } = useReportListing()

const resultAnalyzes = ref<ResultAnalyzesType>({
  color: null,
  index: {
    apiLange: 0,
    color: '',
    day: 0,
    fedorovVolodkina: 0,
    greenVermillion: 0,
    long: 0,
    php: 0,
    cfe: {
      caries: null,
      filling: null,
      extracted: null,
    },
  },
  stoneList: [],
  isPigmented: false,
  dateAt: '',
})

const consultation = ref<ConsultationType>({
  consultations: [],
  fullConsultationList: undefined,
  reCleaning: 0,
})

const appointments = ref<AppointmentType>()
const observationHistory = ref<ObservationHistoryType[]>([])

const loading = ref(false)
const analyzesLoading = ref(false)
const recommendationsLoading = ref(false)
const isLinkedPatient = ref(false)
const isSendedReport = ref(false)

const reportInfo = ref<ReportDetailType>({
  id: 0,
  date_at: '',
  images: [],
  organization: undefined,
  doctor: undefined,
})

const comments = ref<CommentType[]>([])
const commentTemplates = ref<CommentTemplateType[]>([])

const email = ref('')

let userId: number

const reportId = computed<string>(() => route.params.reportId as string)
const patientId = computed<string>(() => route.params.patientId as string)
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const maxEnabled = computed(() => process.env.VUE_APP_MAX_ENABLE === 'true')
const maxSendEnabled = computed(
  () => process.env.VUE_APP_UI_MAX_BLOCK_ENABLE === 'true'
)
const plaqueReportController = ref(new PlaqueReportController())
const isLoaded = ref(false)

const getFullInfo = async (): Promise<void> => {
  await getReportInfo()
  await getUserInfo()
}

const getReportInfo = async (): Promise<void> => {
  if (!reportId.value) return

  const [error, response] = await reportApi.getReport(Number(reportId.value))

  if (error) {
    showErrorMessage(error)
  } else {
    plaqueReportController.value = new PlaqueReportController()
    plaqueReportController.value.setReportData(response.data)
    reportInfo.value = response.data.report
    userId = response.data.report.user_id
    consultation.value = plaqueReportController.value.getConsultationList()
    appointments.value = plaqueReportController.value.getAppointments()
    commentTemplates.value = plaqueReportController.value.getCommentsTemplates()
    comments.value = response.data.comments

    await loadAnalyzesResult()
    await getOrganizationInfo(response.data.report.organization_id)

    if (patientId.value && patientId.value !== 'null-patient') {
      isLinkedPatient.value = response.data.report.patient.sent_to_bot === 1
      isSendedReport.value = response.data.report.report_sent_to_bot
      observationHistory.value =
        plaqueReportController.value.getObservationHistory()
      await getPatientEmail()
    }
  }

  loading.value = false
}

const getOrganizationInfo = async (organizationId: number): Promise<void> => {
  const [error, response] = await organizationsApi.getOrganizationInfo(
    organizationId
  )

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.organization = response.data.organization
  }
}

const loadAnalyzesResult = async (): Promise<void> => {
  if (!reportId.value) return

  const [error, response] = await reportApi.getReport(Number(reportId.value))

  if (error) {
    showErrorMessage(error)
  } else if (response.data.color) {
    plaqueReportController.value.setReportData(response.data)
    resultAnalyzes.value =
      await plaqueReportController.value.getAnalyzesResult()
    appointments.value = plaqueReportController.value.getAppointments()
    consultation.value = plaqueReportController.value.getConsultationList()
  } else {
    ElMessage({
      type: 'warning',
      message: 'Некоторые данные еще загружаются',
      duration: 1500,
    })
    getAnalyzesResultEveryThreeSeconds()
  }
}

const getAnalyzesResultEveryThreeSeconds = (): void => {
  const MAX_COUNT_REQUESTS = 14
  let countRequests = 0

  analyzesLoading.value = true

  const interval = setInterval(async () => {
    if (!reportId.value) {
      clearInterval(interval)
      return
    }

    const [error, response] = await reportApi.getReport(Number(reportId.value))
    if (error) {
      showErrorMessage(error)
    } else {
      countRequests++
      plaqueReportController.value.setReportData(response.data)

      if (countRequests === MAX_COUNT_REQUESTS || response.data.color) {
        resultAnalyzes.value =
          await plaqueReportController.value.getAnalyzesResult()
        consultation.value = plaqueReportController.value.getConsultationList()
        appointments.value = plaqueReportController.value.getAppointments()

        setUpdateReportListing(true)

        analyzesLoading.value = false
        clearInterval(interval)
      }
    }
  }, 3000)
}

const getPatientEmail = async (): Promise<void> => {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    email.value = response.data.patient.email
  }
}

const getUserInfo = async (): Promise<void> => {
  const [error, response] = await userApi.getUser(userId)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.doctor = response.data.user
  }
}

watch(reportId, (newReportId) => {
  if (route.name === 'PlaqueIndexReportPage' && newReportId) {
    getFullInfo()
  }
})

onMounted(async () => {
  await getFullInfo()
  isLoaded.value = true
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'plaque-report-page__wrapper--preview': _unref(isPreviewMode) }, "plaque-report-page__wrapper"])
    }, [
      _createVNode(_unref(WReportHeader), {
        "is-lock-preview": !Boolean(resultAnalyzes.value.color),
        "report-info": reportInfo.value,
        "report-type": _unref(REPORT_VIEW).plaqueIndex
      }, null, 8, ["is-lock-preview", "report-info", "report-type"]),
      (_unref(isPreviewMode) && isLoaded.value)
        ? (_openBlock(), _createBlock(PlaqueReportPreview, {
            key: 0,
            "plaque-report-controller": plaqueReportController.value,
            appointments: appointments.value,
            comments: comments.value,
            consultation: consultation.value,
            "observation-history": observationHistory.value,
            "report-info": reportInfo.value,
            "result-analyzes": resultAnalyzes.value
          }, null, 8, ["plaque-report-controller", "appointments", "comments", "consultation", "observation-history", "report-info", "result-analyzes"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(WReportImages), {
          images: reportInfo.value.images,
          rotate: "",
          onRotated: getFullInfo
        }, null, 8, ["images"]),
        _withDirectives(_createVNode(_unref(EResultAnalyzes), {
          "plaque-report-controller": plaqueReportController.value,
          "result-analyzes": resultAnalyzes.value,
          class: "plaque-report-page__card"
        }, null, 8, ["plaque-report-controller", "result-analyzes"]), [
          [_directive_loading, analyzesLoading.value]
        ]),
        (_unref(patientId) !== 'null-patient')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(EObservationHistory), {
                "observation-history": observationHistory.value,
                class: "plaque-report-page__card"
              }, null, 8, ["observation-history"]),
              _withDirectives(_createVNode(_unref(WReportRecommendations), {
                "possibility-appoint-consultation": true,
                consultation: consultation.value,
                "is-plaque-report": true,
                class: "plaque-report-page__card",
                onUpdated: getReportInfo
              }, null, 8, ["consultation"]), [
                [_directive_loading, recommendationsLoading.value]
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_unref(WReportComments), {
          comments: comments.value,
          "is-old": false,
          "report-type": _unref(REPORT_VIEW).plaqueIndex,
          templates: commentTemplates.value,
          class: "plaque-report-page__card",
          onUpdate: getReportInfo
        }, null, 8, ["comments", "report-type", "templates"]),
        (_unref(patientId) !== 'null-patient')
          ? (_openBlock(), _createBlock(_unref(WReportSubmit), {
              key: 1,
              email: email.value,
              "report-type": _unref(REPORT_VIEW).plaqueIndex
            }, null, 8, ["email", "report-type"]))
          : _createCommentVNode("", true),
        (_unref(patientId) !== 'null-patient')
          ? (_openBlock(), _createBlock(_unref(WReportPrint), {
              key: 2,
              "url-part": 'reports/report'
            }))
          : _createCommentVNode("", true),
        (_unref(patientId) !== 'null-patient' && _unref(maxEnabled) && _unref(maxSendEnabled))
          ? (_openBlock(), _createBlock(_unref(WSendToBot), {
              key: 3,
              onUpdateSendedStatus: _cache[0] || (_cache[0] = ($event: any) => (isSendedReport.value = true)),
              onUpdateLinkedStatus: _cache[1] || (_cache[1] = ($event: any) => (isLinkedPatient.value = true)),
              "report-name": "plaqueIndex",
              "is-sended": isSendedReport.value,
              "is-linked": isLinkedPatient.value
            }, null, 8, ["is-sended", "is-linked"]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !_unref(isPreviewMode)]
      ]),
      (_unref(isPreviewMode))
        ? (_openBlock(), _createBlock(_unref(WReportHeader), {
            key: 1,
            position: "bottom",
            "report-info": reportInfo.value,
            "report-type": _unref(REPORT_VIEW).plaqueIndex
          }, null, 8, ["report-info", "report-type"]))
        : _createCommentVNode("", true)
    ], 2)
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { body: true }
    ]
  ])
}
}

})